import { Thumbnail, token } from '@bynder/design-system';
import {
  useActiveThemeset,
  useGetThemesetColors,
} from '../../../../../queries/themesets';
import { defaultTransparent } from '../../../../widgets/RichText/Config';
import InspectorPanelColorPicker from '../../ColorPicker';
import { SettingsAccordion } from '../../SettingsAccordion';
import { CSS_METAPROPERTIES, CSS_PROPERTIES } from '../../constants';
import { useTranslate } from '@bynder/localization';
import { useCustomCSSEditor } from '../../../../../hooks/useCustomCSSEditor';
import { IconColor } from '@bynder/icons';

const ButtonBackground = ({ style, handleStyleChange }) => {
  const { data: themeset } = useActiveThemeset();
  const { translate } = useTranslate();
  const customColors = [...useGetThemesetColors(), defaultTransparent];

  const { findColorFromStyle, clearStyle, addColorToStyle } =
    useCustomCSSEditor(style);

  const handleClear = (property, selector?) => {
    const newStyle = clearStyle(property, selector);
    handleStyleChange(newStyle);
  };

  const handleClick = (colorId, property, selector?) => {
    const newStyle = addColorToStyle(colorId, property, selector);
    handleStyleChange(newStyle);
  };

  const defaultButtonBackgroundColor =
    themeset?.widgets.button.colors.default.backgroundColor?.hexCode ||
    token.brandPrimary500;
  const defaultButtonHoverBackgroundColor =
    themeset?.widgets.button.colors.hover.backgroundColor?.hexCode ||
    token.brandPrimary700;

  return (
    <>
      <SettingsAccordion
        thumbnail={<Thumbnail icon={<IconColor />} />}
        title="Background"
      >
        <InspectorPanelColorPicker
          testId="buttonBackgroundColorDefault"
          colors={customColors}
          label={translate('WIDGET_INSPECTOR.BUTTON_DEFAULT')}
          handleClear={() => {
            handleClear(CSS_PROPERTIES.BACKGROUND_COLOR);
          }}
          defaultColorHex={defaultButtonBackgroundColor}
          activeColor={findColorFromStyle(CSS_PROPERTIES.BACKGROUND_COLOR)}
          handleClick={colorId => {
            handleClick(colorId, CSS_PROPERTIES.BACKGROUND_COLOR);
          }}
        />
        <InspectorPanelColorPicker
          testId="buttonBackgroundColorHover"
          colors={customColors}
          defaultColorHex={defaultButtonHoverBackgroundColor}
          label={translate('WIDGET_INSPECTOR.BUTTON_HOVER')}
          handleClear={() => {
            handleClear(
              CSS_PROPERTIES.BACKGROUND_COLOR,
              `&${CSS_METAPROPERTIES.HOVER}`,
            );
          }}
          activeColor={findColorFromStyle(
            CSS_PROPERTIES.BACKGROUND_COLOR,
            CSS_METAPROPERTIES.HOVER,
          )}
          handleClick={colorId => {
            handleClick(
              colorId,
              CSS_PROPERTIES.BACKGROUND_COLOR,
              `${CSS_METAPROPERTIES.HOVER}`,
            );
          }}
        />
      </SettingsAccordion>
    </>
  );
};

export default ButtonBackground;
